export const twitterInit = config => {
  document.addEventListener('page:load', ({ detail }) => {
    const { page, project } = detail;

    if (project?.brand === 'acom' && ['search', 'category'].includes(page?.type)) {
      return null;
    }

    const twitterTag = `
    try{
        !function(e,t,n,s,u,a){e.twq||(s=e.twq=function(){s.exe?s.exe.apply(s,arguments):s.queue.push(arguments);
      },s.version='1.1',s.queue=[],u=t.createElement(n),u.async=!0,u.src='//static.ads-twitter.com/uwt.js',
      a=t.getElementsByTagName(n)[0],a.parentNode.insertBefore(u,a))}(window,document,'script');
      // Insert Twitter Pixel ID and Standard Event data below
          twq('init','${config.twitter}');
          twq('track','PageView');
      } catch(e) {
          console.log(e)
      }
  `;

    const head = document.getElementsByTagName('head')[0];
    const script = document.createElement('script');
    script.async = 1;
    script.text = twitterTag;
    head.appendChild(script);
  });
};
